export default {
    file: 'src/content/pages/home.json',
    label: 'Koduleht',
    name: 'home',
    i18n : true,
    fields: [
        {
            label: 'Title',
            name: 'title',
            widget: 'string',
            default: '',
            i18n: true,
            required: true,
        },
        {
            label: 'Description (SEO Keywords)',
            name: 'description',
            widget: 'string',
            default: '',
            i18n: true,
            required: true,
        },
        {
            label: 'Slug',
            name: 'slug',
            widget: 'string',
            default: '',
            i18n: true,
            required: true,
        },
        {
            label: 'Call to Action Section',
            name: 'cta_section',
            widget: 'object',
            default: '',
            i18n: true,
            required: true,
            fields : [
                {
                    label: 'Primary Button',
                    name: 'primary_button',
                    widget: 'object',
                    i18n: true,
                    required: true,
                    fields: [
                        {
                            label: 'Text',
                            name: 'text',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'URL',
                            name: 'url',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Enabled',
                            name: 'enabled',
                            widget: 'boolean',
                            i18n: true,
                            required: true,
                        }
                    ]
                },
                {
                    label: 'Secondary Button',
                    name: 'secondary_button',
                    widget: 'object',
                    default: '',
                    i18n: true,
                    required: true,
                    fields: [
                        {
                            label: 'Text',
                            name: 'text',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'URL',
                            name: 'url',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Enabled',
                            name: 'enabled',
                            widget: 'boolean',
                            i18n: true,
                            required: true,
                        }
                    ]
                },
            ]
        },
        {
            label: 'About Section',
            name: 'about_section',
            widget: 'object',
            default: '',
            i18n: true,
            required: true,
            fields : [
                {
                    label: 'Title',
                    name: 'title',
                    widget: 'string',
                    default: '',
                    i18n: true,
                    required: true,
                },
                {
                    label: 'Content',
                    name: 'content',
                    widget: 'text',
                    default: '',
                    i18n: true,
                    required: true,
                },
                {
                    label: 'Statistics',
                    name: 'statistics',
                    widget: 'list',
                    default: '',
                    i18n: true,
                    required: true,
                    fields: [
                        {
                            label: 'Title',
                            name: 'title',
                            widget: 'string',
                            default: '',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Value',
                            name: 'value',
                            widget: 'string',
                            default: '',
                            i18n: 'duplicate',
                            required: true,
                        }
                    ]
                }
            ]
        },
        {
            label: 'Services Section',
            name: 'services_section',
            widget: 'object',
            default: '',
            i18n: true,
            required: true,
            fields : [
                {
                    label: 'Title',
                    name: 'title',
                    widget: 'string',
                    default: '',
                    i18n: true,
                    required: true,
                },
                {
                    label: 'Description',
                    name: 'description',
                    widget: 'text',
                    default: '',
                    i18n: true,
                    required: true,
                },
            ]
        },
        {
            label: 'Offers Section',
            name: 'offers_section',
            widget: 'object',
            i18n: true,
            required: true,
            fields : [
                {
                    label: 'Offers',
                    name: 'offers',
                    widget: 'list',
                    i18n: true,
                    required: true,
                    fields: [
                        {
                            label: 'Title',
                            name: 'title',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Description',
                            name: 'description',
                            widget: 'string',
                            i18n: true,
                            required: true,
                        },
                        {
                            label: 'Image',
                            name: 'image',
                            widget: 'object',
                            i18n: true,
                            required: true,
                            fields: [
                                {
                                    label: 'Image',
                                    name: 'image',
                                    widget: 'image',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Caption',
                                    name: 'caption',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Load Width (px)',
                                    name: 'width',
                                    widget: 'number',
                                    value_type: 'int',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'Load Height (px)',
                                    name: 'height',
                                    widget: 'number',
                                    value_type: 'int',
                                    i18n: true,
                                    required: true,
                                },
                            ]
                        },
                        {
                            label: 'CTA',
                            name: 'cta',
                            widget: 'object',
                            i18n: true,
                            required: true,
                            fields: [
                                {
                                    label: 'Text',
                                    name: 'text',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                },
                                {
                                    label: 'URL',
                                    name: 'url',
                                    widget: 'string',
                                    i18n: true,
                                    required: true,
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            label: 'Gallery Section',
            name: 'gallery_section',
            widget: 'object',
            default: '',
            i18n: true,
            required: true,
            fields : [
            {
                label: 'Locations',
                name: 'locations',
                widget: 'list',
                default: '',
                i18n: true,
                required: true,
                fields : [
                    {
                        label: 'Title',
                        name: 'title',
                        widget: 'string',
                        default: '',
                        i18n: true,
                        required: true,
                    },
                    {
                        label: 'Sub Title',
                        name: 'subtitle',
                        widget: 'string',
                        default: '',
                        i18n: true,
                        required: true,
                    },
                    {
                        label: 'Images',
                        name: 'images',
                        widget: 'list',
                        default: '',
                        i18n: true,
                        required: true,
                        fields: [
                            {
                                label: 'Image',
                                name: 'image',
                                widget: 'image',
                                default: '',
                                i18n: true,
                                required: true,
                            },
                            {
                                label: 'Caption',
                                name: 'caption',
                                widget: 'string',
                                default: '',
                                i18n: true,
                                required: true,
                            },
                            {
                                label: 'Load Width (px)',
                                name: 'width',
                                widget: 'number',
                                value_type: 'int',
                                i18n: true,
                                required: true,
                            },
                            {
                                label: 'Load Height (px)',
                                name: 'height',
                                widget: 'number',
                                value_type: 'int',
                                i18n: true,
                                required: true,
                            },
                            ]
                        },
                    ]
                },
            ]
        },
        {
            label: 'Contact Section',
            name: 'contact_section',
            widget: 'object',
            default: '',
            i18n: true,
            required: true,
            fields : [
                {
                    label: 'Title',
                    name: 'title',
                    widget: 'string',
                    default: '',
                    i18n: true,
                    required: true,
                },
                {
                    label: 'Description',
                    name: 'description',
                    widget: 'string',
                    default: '',
                    i18n: true,
                    required: true,
                },
            ]
        }
    ]
}